import { z } from "zod";
import { MeetingExternalGuestStatus } from "../enum.js";

export const meetingExternalGuestSchema = z.object({
	id: z.uuid(),
	meeting_id: z.uuid(),
	email: z.email(),
	first_name: z.string().nullable(),
	last_name: z.string().nullable(),
	status: z.enum(MeetingExternalGuestStatus),
	created_at: z.iso.datetime(),
	updated_at: z.iso.datetime(),
});

export type MeetingExternalGuest = z.infer<typeof meetingExternalGuestSchema>;
